import type { ReactNode } from "react";
import { Label } from "@/components/ui/label";

interface FormFieldProps {
    label: string;
    required?: boolean;
    children: ReactNode;
    className?: string;
    error?: string;
}

export function FormField({
    label,
    required = false,
    children,
    className = "",
    error,
}: FormFieldProps) {
    return (
        <div className={`flex flex-col gap-1.5 ${className}`}>
            <Label className="text-xs font-semibold uppercase tracking-wide text-slate-700 dark:text-slate-400">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </Label>
            {children}
            {error && <p className="text-xs text-red-500">{error}</p>}
        </div>
    );
}